import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const GetInTouchSection = styled.div`
    padding-top: .5rem;
    >h4{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.fourth};
    }
`
export const GetInTouchCard = styled.div`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    >h4{
        text-align:center;
        position: relative;
        margin-bottom:2rem;
        font-size:24px;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.first};
        &::after{
            position: absolute;
            content: '';
            height: 2px;
            bottom: -8px; 
            margin: 0 auto;
		    left: 0;
            right: 0;
		    width: 25%;
		    background-color: ${({ theme }) => theme.color.second};
        }
    }
    div:last-child{
        margin-bottom:0rem
    }
    input{
        width: 100%;
        border: none;
        margin-bottom: 1rem;
        outline: none; 
        padding:1rem 1rem;
        border-radius:10px;
        background-color: ${({ theme }) => theme.color.second};
        color: ${({ theme }) => theme.color.sixth};
        font-family:${({ theme }) => theme.font.second};
        font-size:14px;
        box-shadow: 0 0 10px ${({ theme }) => theme.color.sixth};

    }
    input:focus{
        box-shadow: 0 0 10px ${({ theme }) => theme.color.gray};
    }
    textarea{
        width: 100%;
        height: 10rem;
        border: none;
        margin-bottom: .5rem;
        outline: none; 
        padding:1rem 1rem;
        border-radius:10px;
        background-color: ${({ theme }) => theme.color.second};
        color: ${({ theme }) => theme.color.sixth};
        font-family:${({ theme }) => theme.font.second};
        font-size:14px;
        box-shadow: 0 0 10px ${({ theme }) => theme.color.sixth};

        ::-webkit-scrollbar {
            width: 5px;
        }
        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px ${({ theme }) => theme.color.second}; 
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.color.third}; 
            border-radius: 10px;
        }
    }
    textarea:focus{
        box-shadow: 0 0 10px ${({ theme }) => theme.color.gray};
    }
    button{
        display: block;
        padding: 1rem 3rem;
        border: none;
        background:red;
        border-radius:10px;        
        margin:10px auto;
        font-weight:500;
        background-color: ${({ theme }) => theme.color.second};
        color: ${({ theme }) => theme.color.sixth};
        font-family:${({ theme }) => theme.font.first};
        box-shadow:  0 0 10px ${({ theme }) => theme.color.sixth}; 
    }
    button:active{
        box-shadow: inset 0 0 10px ${({ theme }) => theme.color.sixth}; 
        color: ${({ theme }) => theme.color.gray};
    }
`